import moment from 'moment';

export const getBankAccountHoldersOptions = (account_type, interveners) => {
    // Cuentas jurídicas -> persona jurídica
    if (account_type === 'J') {
        return interveners.filter(
            intervener =>
                intervener.personalData?.intervener_type === 'J' ||
                intervener.intervener_type === 'J'
        );
    }

    // Cuentas  con menores -> cualquier tutor o titular (los menores tambien pueden ser seleccionado)
    const hasMinor = interveners.some(
        intervener =>
            moment().diff(intervener.birthdate || intervener.personalData.birthdate, 'years') < 18
    );

    if (hasMinor) {
        const holders = interveners.filter(intervener => {
            const intervenerRoles = intervener.account_roles
                ? intervener.account_roles.map(accountRole => accountRole.account_intervener_role)
                : intervener.account_intervener_role || [];

            return intervenerRoles.some(rol =>
                ['TUTOR', 'NUDO_PROPIETARIO', 'TITULAR'].includes(rol.toUpperCase())
            );
        });

        return holders;
    }

    // cuentas físicas -> cualquier titular/nudo propietario
    if (account_type === 'F') {
        const holders = interveners.filter(intervener => {
            const intervenerRoles = intervener.account_roles
                ? intervener.account_roles.map(accountRole => accountRole.account_intervener_role)
                : intervener.account_intervener_role || [];

            return intervenerRoles.some(rol =>
                ['TITULAR', 'NUDO_PROPIETARIO'].includes(rol.toUpperCase())
            );
        });
        return holders;
    }
};
